// @flow
import memoize from "lru-memoize"
import * as R from "ramda"

import template from "common/utils/template"

export const getRidOfZeroMinutes = R.replace(new RegExp(" *m+(\\[.*\\])+ *"), "")

// mostly the format is just one of these possibilities alone, memoi helps! language is redundant
export const getFormat = memoize(10)((language, format) =>
  template(format)(
    R.pick(
      [
        "dateFormat",
        "dateFormatShort",
        "dateFormatPlain",
        "timeFormat",
        "durationFormat",
        "durationFormatShort",
        "dateFormatLong",
      ],
      language,
    ),
  ),
)
